export default __webpack_public_path__ + "static/media/logo.ea618c71.png";